document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const openButton = event.target.closest('[data-ya-menu-open]');
  const closeButton = event.target.closest('[data-ya-menu-close]');
  const menu = document.querySelector('[data-ya-mobile-menu]');

  if (openButton && menu) {
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ya-menu-open');
  }

  if ((closeButton || event.target === menu) && menu) {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ya-menu-open');
  }

  const qtyButton = event.target.closest('[data-ya-qty]');
  if (qtyButton) {
    const wrapper = qtyButton.closest('[data-ya-quantity]');
    const input = wrapper?.querySelector('input[type="number"]');
    if (!input) return;

    const direction = qtyButton.dataset.yaQty;
    const min = Number(input.min || 1);
    const current = Number(input.value || min);
    input.value = Math.max(min, current + (direction === 'plus' ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-ya-variant-select]');
  if (!select) return;

  const option = select.options[select.selectedIndex];
  const section = select.closest('[data-ya-product-section]');
  if (!section || !option) return;

  const price = section.querySelector('[data-ya-product-price]');
  const compare = section.querySelector('[data-ya-compare-price]');
  const addButton = section.querySelector('[data-ya-add-button]');
  const availability = option.dataset.available === 'true';

  if (price && option.dataset.price) price.textContent = option.dataset.price;

  if (compare) {
    compare.textContent = option.dataset.compare || '';
    compare.hidden = !option.dataset.compare;
  }

  if (addButton) {
    addButton.disabled = !availability;
    addButton.textContent = availability
      ? addButton.dataset.availableText
      : addButton.dataset.soldoutText;
  }

  if (history.replaceState && option.value) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
  }
});
